export enum EBucketNames {
  ABONENT_REQUEST = "ABONENT_REQUEST",
  ACT_INVENTARISATION = "ACT_INVENTARISATION",
  ACT = "ACT",
  COMPANY_STAFF = "COMPANY_STAFF",
  DISABLED_ABONENT_STACK = "DISABLED_ABONENT_STACK",
  KVIT = "KVIT",
  PRECRIBED_ACT = "PRECRIBED_ACT",
  SPECIFIC_ACT = "SPECIFIC_ACT",
  STACK_ACT = "STACK_ACT",
  SUD_PROCESS = "SUD_PROCESS",
  COMPANY_CONTRACTS = "COMPANY_CONTRACTS",
  PUBLIC_MAHALLA_CONTRACTS = "PUBLIC_MAHALLA_CONTRACTS",
  FROZEN_MAHALLA = "FROZEN_MAHALLA",
  DXSH = "DXSH",
  LEASING = "LEASING",
  POLYGON = "POLYGON",
  TARIFF = "TARIFF",
  VISITS_GRAPH = "VISITS_GRAPH",
  VISITS_GRAPH_CONTROL = "VISITS_GRAPH_CONTROL",
  FOLDER_1031 = "FOLDER_1031",
  CANCELED_PAYMENT_FILES = "CANCELED_PAYMENT_FILES",
}
